import { render, staticRenderFns } from "./ThuliumChat.vue?vue&type=template&id=a9e41e3a"
import script from "./ThuliumChat.vue?vue&type=script&lang=js"
export * from "./ThuliumChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports